module.exports = __webpack_public_path__ + "static/img/1970_phase_function_Paper_Points.4800b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1970_phase_function_Paper_Points.png
// module id = jdgt
// module chunks = 0